import { render, staticRenderFns } from "./ManageChatNew.vue?vue&type=template&id=0b0851a6&scoped=true&"
import script from "./ManageChatNew.vue?vue&type=script&lang=js&"
export * from "./ManageChatNew.vue?vue&type=script&lang=js&"
import style0 from "./ManageChatNew.vue?vue&type=style&index=0&id=0b0851a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0851a6",
  null
  
)

export default component.exports